import { makeInventoryRequestKey } from "./inventory-format";

const prefix = "promang:purchase-create-attempt:";
export const purchaseCreateAttemptKey = (companyId) => `${prefix}${companyId}`;

export function readPurchaseCreateAttempt(companyId, storage) {
  if (companyId == null) return null;
  try {
    const saved = JSON.parse((storage || sessionStorage).getItem(purchaseCreateAttemptKey(companyId)) || "null");
    return saved?.companyId === companyId && /^[0-9a-f-]{36}$/i.test(saved.requestKey || "") && saved.payload?.request_key === saved.requestKey
      ? saved : null;
  } catch (_) { return null; }
}

export function startPurchaseCreateAttempt(companyId, draft, supplierName, storage = sessionStorage) {
  if (companyId == null) throw new Error("Company is required");
  const requestKey = makeInventoryRequestKey();
  const attempt = { companyId, requestKey, supplierName, payload: {
    supplier_id: Number(draft.supplier_id),
    purchase_date: draft.purchase_date,
    delivery_date: draft.delivery_date || null,
    reference: draft.reference || "",
    status: "draft",
    request_key: requestKey,
  } };
  storage.setItem(purchaseCreateAttemptKey(companyId), JSON.stringify(attempt));
  return attempt;
}

export function clearPurchaseCreateAttempt(companyId, storage = sessionStorage) {
  if (companyId != null) storage.removeItem(purchaseCreateAttemptKey(companyId));
}
